import { t } from "@redotech/redo-i18n";
import { SkuOption } from "@redotech/redo-return-core-common/condition-options";
import { Condition as ModelCondition } from "@redotech/redo-return-core-common/return-flow/condition";
import { SkuMatchType } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  skuFromModel,
  validateSkuCondition,
  type SkuState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const SKU = (
  Details: React.ComponentType<ConditionTypeDetailsProps<SkuState>>,
): ConditionType<SkuState, ModelCondition.Sku> => ({
  name: CONDITION_NAMES[ModelCondition.SKU],
  description(state) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    switch (state.skuOption!) {
      case SkuOption.EQUALS:
        return t("{{field}} matches one from list", { field: "SKU" });
      case SkuOption.STARTS_WITH:
        return t("{{field}} starts with one from list", { field: "SKU" });
      case SkuOption.ENDS_WITH:
        return t("{{field}} ends with one from list", { field: "SKU" });
      case SkuOption.INCLUDES:
        return t("{{field}} includes one from list", { field: "SKU" });
    }
  },
  Details(props: ConditionTypeDetailsProps<SkuState>) {
    return React.createElement(Details, props);
  },
  empty: {
    codes: [],
    skuOption: SkuOption.EQUALS,
    matchType: SkuMatchType.ALL,
  },
  fromModel(model: ModelCondition.Sku) {
    return skuFromModel(model);
  },
  toModel(state) {
    return {
      type: ModelCondition.SKU,
      codes: state.codes,
      skuOption: state.skuOption || null,
      matchType: state.matchType,
    };
  },
  valid(state) {
    return validateSkuCondition(state).valid;
  },
});
